import client from '/src/services/client.js';
// Endpoint api bots
export default {
    getBotInformations : (name) => client.get(`bot/information/${name}`),
    deleteVariable : (bot_id, id) => client.delete(`bot/${bot_id}/variable/${id}`),
    addVariable : (bot_id, data) => client.post(`bot/${bot_id}/variable`, data),
    importTemplate : (bot_id, data) => client.post(`bot/${bot_id}/scenario/import`, data),
    getTelephonyInfo : (name) => client.get(`bot/${name}/info/telephony`)
}